<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-card-title class="themed-card-title">
          Application Status
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              Email verification:
              <span class="success--text" v-if="$store.state.user.emailVerified"
                >Completed</span
              >
              <span class="error--text" v-else
                >Pending...
                <v-btn
                  class="ml-3"
                  small
                  color="accent"
                  :loading="loading"
                  :disabled="disabled"
                  @click="resendEmail"
                  >{{ btnText }}</v-btn
                ></span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Data access approvement:
              <span class="success--text" v-if="$store.state.user.accessGranted"
                >Completed</span
              >
              <span class="error--text" v-else>Pending...</span>
            </v-col>
          </v-row>
          <p class="mt-5">
            You will be able to access the database once you have completed your
            email verification and your request has been approved by the
            administrator.
          </p>
          <p>
            You will receive a confirmation email when your account has been
            authorised.
          </p>
          <p>
            Please contact
            {{ $store.state.websiteVariables.corresponderName }} at
            <a
              :href="
                `mailto:${$store.state.websiteVariables.corresponderEmail}`
              "
              >{{ $store.state.websiteVariables.corresponderEmail }}</a
            >
            for enquiries about your data access approvement.
          </p>
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "@/firebase";
const functions = firebase.functions("europe-west2");
const resendVerificationEmail = functions.httpsCallable(
  "emails-resendVerificationEmail"
);

export default {
  data: () => ({
    loading: false,
    disabled: false,
    btnText: "Resend email"
  }),
  methods: {
    async resendEmail() {
      this.loading = true;

      await resendVerificationEmail();

      this.loading = false;
      this.btnText = "Email sent";
      this.disabled = true;
    }
  }
};
</script>
